var addCommas = null;
var undef = null;
var SortByLgh = null;
var sortNumber = null;
var supportsSVG = null;
var getRoomString = null;

(function ($) {

    Array.prototype.contains = function (obj) {
        var i = this.length;
        while (i--) {
            if (this[i] == obj) {
                return true;
            }
        }
        return false;
    };

    Array.prototype.max = function () {
        return Math.max.apply(null, this);
    };

    Array.prototype.min = function () {
        return Math.min.apply(null, this);
    };



    missingNumbers = function (numbers) {

        var max = numbers.max();
        var min = numbers.min();

        for (var i = 0; i < max; i++) {
            var n = i;
            var found = false;
            for (var k = 0; k < numbers.length; k++) {
                if (numbers[k] === n) {
                    found = true;
                }
            }

            if (!found && n > min && n < max) {
                numbers.push("" + n + "");
            }

        }

        numbers = numbers.sort(sortNumber);
        return numbers;
    };

    getRoomString = function (rooms) {
        var rs = "";
        for (var i = 0; i < rooms.length; i++) {
            rs += "-" + rooms[i].replace(".", ",");
        }
        rs = rs.substr(1);
        return rs;
    };

    SortByLgh = function (a, b) {
        var aNr = parseInt(a.std_LghNr);
        var bNr = parseInt(b.std_LghNr);
        return aNr - bNr;
    };

    sortNumber = function (a, b) {
        return a - b;
    };

    //Check if browser supports svg
    supportsSVG = function (a, b) {
        return !!((b = 'createElementNS') in (a = document) && a[b]('http://www.w3.org/2000/svg', 'svg').createSVGRect);
    };

    addCommas = function (nStr, status) {
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }

        var rStr = x1 + x2;

        if (status == 'available' || !status) {
            return rStr;
        }

        return '-';

    };

    undef = function (o) {
        return typeof o === 'undefined';
    };

    SVGElement.prototype.hasClass = function (className) {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.getAttribute('class'));
    };

    SVGElement.prototype.addClass = function (className) {
        if (!this.hasClass(className)) {
            this.setAttribute('class', this.getAttribute('class') + ' ' + className);
        }
    };

    SVGElement.prototype.removeClass = function (className) {
        if (this.hasAttribute('class')) {
            var removedClass = this.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
            if (this.hasClass(className)) {
                this.setAttribute('class', removedClass);
            }
        }
    };

    SVGElement.prototype.toggleClass = function (className) {
        if (this.hasClass(className)) {
            this.removeClass(className);
        } else {
            this.addClass(className);
        }
    }; 


})(jQuery, SVGElement);


